<template>
  <el-dialog
    v-bind="$attrs"
    destroy-on-close
    custom-class="liability"
    center
    v-on="$listeners"
    @open="getSimulate"
  >
    <div class="titlecontent">
      <img src="@/assets/images/accident/video3.png" class="video2">
      <span class="titletext">定责</span>
      <img src="@/assets/images/accident/video2.png" class="video3">
    </div>

    <img src="@/assets/images/list/ang1.png" class="ang1">
    <img src="@/assets/images/list/ang2.png" class="ang2">
    <img src="@/assets/images/list/ang3.png" class="ang3">
    <img src="@/assets/images/list/ang4.png" class="ang4">

    <div class="responsible-category">
      <div class='responsible-category-area'>
        <span class='responsible-title'><span>*</span>定责类目：</span>
        <el-select v-model="responsibleCategorySelect">
          <el-option v-for="item in responsibleCategory" :key="item.value" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
    </div>

    <div class='responsible-person-area'
         v-show="responsibleCategory.find(item=>item.value===responsibleCategorySelect).isSubmission">
      <span class='responsible-person-title'><span>*</span>责任人</span>
      <div class='responsible-person-children'>
        <div class='responsible-person-children-row' v-for="(item,index) in responsibleList" :key="item.id">
          <span class='responsible-person-children-title'>{{ item.name ? item.name : `当事人${index + 1}` }}：</span>
          <el-checkbox v-model="item.checked">有责</el-checkbox>
        </div>
      </div>
      <div class='responsible-submission-area' v-show="submissionBook">
        <span class='responsible-submission' @click="downFile">责任初步意见书.pdf</span>
      </div>
      <div class='responsible-person-btn-area' v-show="!submissionBook">
        <span class='responsible-person-btn' @click="getSubmissionBook">生成意见书</span>
      </div>
    </div>

    <div class='add-accident-certificate-area'
         v-show="responsibleCategory.find(item=>item.value===responsibleCategorySelect).isSubmission && !confirmationShow">
      <span class='add-accident-certificate-btn' @click="toggleConfirmationShow">添加事故认定书</span>
    </div>

    <ul class="liability-list"
        v-show="!responsibleCategory.find(item=>item.value===responsibleCategorySelect).isSubmission || confirmationShow">
      <li
        v-for="(party, index) in simulate"
        :key="party.id"
      >
        <div class="party-name">
          当事人{{ index + 1 }}{{ party.name }}
        </div>
        <el-form
          ref="form"
          :model="party"
          inline
          :rules="rules"
        >
          <el-form-item
            label="违法条款"
            prop="illegalTerms"
            :rules="[
                {
                  required: party.dutySuggest !== '5',
                  message: '请选择违法条款'
                }
              ]"
          >
            <dict-select
              v-model="party.illegalTerms"
              type="illegal_terms"
            />
          </el-form-item>

          <el-form-item
            label="定责建议"
            prop="dutySuggest"
          >
            <dict-select
              v-model="party.dutySuggest"
              type="duty_suggest"
            />
          </el-form-item>
        </el-form>
      </li>
    </ul>
    <template #footer>
      <el-button
        v-show="!responsibleCategory.find(item=>item.value===responsibleCategorySelect).isSubmission || confirmationShow"
        class="canclebtn"
        icon="el-icon-close"
        :disabled="generateLoading"
        @click="$emit('update:visible')"
      >
        取消
      </el-button>
      <el-button
        v-show="!responsibleCategory.find(item=>item.value===responsibleCategorySelect).isSubmission || confirmationShow"
        class="confirmbtn"
        icon="el-icon-document"
        type="primary"
        :loading="generateLoading"
        @click="generateDocument"
      >
        生成责任书
      </el-button>
      <el-dialog
        :visible.sync="documentVisible"
        :modal="false"
        title="责任认定书"
      >
        <el-form
          ref="documentForm"
          :model="liabilityStatement"
          :rules="{ value: { required: true, message: '请输入责任书内容' } }"
        >
          <el-form-item
            label="编辑"
            prop="value"
          >
            <el-input
              id="textcontent"
              v-model="liabilityStatement.value"
              type="textarea"
              :rows="10"
              placeholder="请输入责任书内容"
            />
          </el-form-item>
        </el-form>

        <template #footer>
          <el-button
            icon="el-icon-close"
            :disabled="loading"
            @click="documentVisible = false"
          >
            取消
          </el-button>
          <el-button
            icon="el-icon-check"
            type="primary"
            :loading="loading"
            @click="liability"
          >
            确认
          </el-button>
        </template>
      </el-dialog>
    </template>
  </el-dialog>
</template>
<script>
import {
  liability,
  getSimulate,
  getAccident,
  submitSubmission,
  getSubmission,
  getResponsibleList
} from '@/api/accident/edit';
import DictSelect from '@/views/accident/components/dict-select';
import myDialog from '@/components/custom/myDialog.vue'
import Responsibility from "@/views/accident/components/responsibility/responsibility";

export default {
  components: {DictSelect, myDialog, Responsibility},
  props: {
    accidentId: String
  },
  data() {
    return {
      documentVisible: false,
      simulate: [],
      responsibleList: [],
      liabilityStatement: {value: ''},
      generateLoading: false,
      confirmationShow: false,
      submissionBook: '',
      responsibleCategorySelect: 1,
      responsibleCategory: [
        {
          label: '责任初步意见书',
          value: 1,
          isSubmission: true
        },
        {
          label: '事故认定书',
          value: 2,
          isSubmission: false
        }
      ],
      dicts: {
        duty_suggest: [],
        illegal_terms: [],
        transportation: [],
        crash_position: []
      },
      rules: {
        dutySuggest: [{required: true, message: '请选择定责建议'}]
      },
      loading: false,
      accident: {},
      agreeStr: '',
      isAgree: false
    };
  },
  computed: {
    dictMaps() {
      return Object.keys(this.dicts).reduce((acc, dictType) => {
        acc[dictType] = this.dicts[dictType].reduce(
          (map, {dictLabel, dictValue}) => {
            map[dictValue] = dictLabel;
            return map;
          },
          {}
        );
        return acc;
      }, {});
    }
  },
  created() {
    this.getNeedDicts();
  },
  methods: {
    toggleConfirmationShow() {
      this.confirmationShow = true
    },
    downFile() {
      let $eleForm = document.createElement('form');
      $eleForm.method = 'get';
      $eleForm.action = this.submissionBook;
      document.body.appendChild($eleForm);
      $eleForm.submit();
      $eleForm.remove()
    },
    getSubmissionBook() {
      const partyInfoBOList = this.responsibleList.filter(item => item.checked).map(item => ({
        id: item.id,
        name: item.name,
        responsibility: 1,
        exemption: 0
      }))
      if (!partyInfoBOList.length) {
        this.$message.error('请选择责任人!')
        return
      }
      submitSubmission({accidentId: this.accidentId, partyInfoBOList}).then(res => {
        this.submissionBook = res.msg
      })
    },
    getNeedDicts() {
      this.getDicts(Object.keys(this.dicts)).then(data => {
        Object.assign(this.dicts, data);
      });
    },
    /**
     * 获取当事人基础事故信息模板
     * @param party 当事人
     */
    getPartyTemplate({
                       name,
                       drivingLicenseNum,
                       idCardNum,
                       carLicenseNum,
                       transportation
                     }) {
      return `${name}（${
        drivingLicenseNum
          ? '驾驶证号：' + drivingLicenseNum
          : '身份证号：' + idCardNum
      }）驾驶车牌为${carLicenseNum || ''}的${this.dictMaps.transportation[
        transportation
        ] || ''}`;
    },
    /**
     * 获取当事人责任文书模板
     * @param party 当事人
     */
    getDutyTemplate({name, id}) {
      const {dutySuggest, illegalTerms} = this.simulate.find(({partyId}) => partyId === id) || {};
      let laws = '《中华人民共和国道路交通安全法》'
      let s = this.dictMaps.illegal_terms[illegalTerms] ? this.dictMaps.illegal_terms[illegalTerms].substr(0, 1) : '0'
      // 测试
      if (s === '1') {
        laws = '《中华人民共和国道路交通安全法》'
      }
      if (s === '2') {
        laws = '《中华人民共和国道路交通安全法实施条例》'
      }
      if (s === '3') {
        laws = '《江苏省道路交通安全条例》'
      }
      return dutySuggest !== '5'
        ? `${name}因违反${laws}“${this.dictMaps.illegal_terms[illegalTerms]}”之规定，负${this.dictMaps.duty_suggest[dutySuggest]}责任`
        : `${name}无责任`;
    },
    async generateDocument() {
      try {
        await Promise.all(this.$refs.form.map(form => form.validate()));
      } catch (err) {
        return '';
      }
      this.generateLoading = true;
      await this.getAccident();
      const [firstParty, ...otherPartys] = this.accident.accidentPartyList;
      let accidentTime = `${this.accident.accidentTime.split(' ')[0].split('-')[0]}年${this.accident.accidentTime.split(' ')[0].split('-')[1]}月${this.accident.accidentTime.split(' ')[0].split('-')[2]}日${this.accident.accidentTime.split(' ')[1].split(':')[0]}时${this.accident.accidentTime.split(' ')[1].split(':')[1]}分`;

      this.liabilityStatement.value = `${
        accidentTime
      }，${this.getPartyTemplate(firstParty)}，在${
        this.accident.accidentAddress
      }，${otherPartys
        .map(party => '与' + this.getPartyTemplate(party))
        .join('，')}发生交通事故，事故导致${this.accident.accidentPartyList
        .filter(({carLicenseNum}) => carLicenseNum)
        .map(
          ({carLicenseNum, crashPosition}) =>
            carLicenseNum + (this.dictMaps.crash_position[crashPosition] || '')
        )
        // TODO 受伤情况
        .join('与') || '无'}受损，${this.accident.accidentPartyList
        .sort(({dutySuggest}) => (dutySuggest ? 1 : -1))
        .map(party => this.getDutyTemplate(party))
        .join('，')}。`;
      this.documentVisible = true;
      this.generateLoading = false;
    },
    async getSimulate() {
      if (!this.accidentId || this.accident.id) {
        return;
      }
      const responsible = await getResponsibleList(this.accidentId)
      this.responsibleList = responsible.data.map(item => ({...item, checked: false}))
      const result = await getSubmission(this.accidentId)
      this.submissionBook = result.msg
      const {data} = await getSimulate(this.accidentId || this.accident.id);
      this.simulate = data.map(item => ({...item, checked: false}));
    },
    liability() {
      this.agreeStr = this.isAgree === true ? '同意接受车损理赔直接赔付给双方车' : '';
      this.liabilityStatement.value === this.liabilityStatement.value + this.agreeStr;
      this.$refs.documentForm.validate().then(() => {
        this.loading = true;
        liability(this.simulate, {
          accidentId: this.accident.id,
          liabilityStatement: this.liabilityStatement.value
        })
          .then(() => {
            this.$emit('ok');
            this.$emit('update:visible', false);
            this.$message.success('定责成功');
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    getAccident() {
      return getAccident(this.accidentId).then(({data}) => {
        this.accident = data;
        this.isAgree = data.directIndemnity === true ? true : false;
      });
    }
  }
};
</script>
<style lang="scss">
.liability {
  position: relative;

  .titlecontent {
    width: 210px;
    height: 30px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANIAAAAgCAYAAABnwyZQAAAEJElEQVR4Xu2db2hVdRjHv88556KN3NDKjYqJmYpgaMMES8owdEt2UQP1Rb6wwCDIF6Uy9c6mu7O1rBcGQUL5wl6YkMmGOiVpiSWYWJEgViaOCrXQtsJc95zzxN04uyvd7jlnc3ed8/29Pb/n93ueD8+Xc/j9eY5gMG29jkExXoIgMZhhaEsCBSWgyKATb6NJ/gjrh4Q1xDa9By4OGuc+myVX20MPQ0MSKDQBHVcOd+oTp2DgaWyUX8P4E05IaZ0A4Ih54oMp5ondCDdIGHdpQwJDT0ABOHNWwpnz7HcAFiAlF4POElwDDTodrraan75zr/V1c3D7oB6yPwkMEwF7ZlKdJ1/8BYZUYpOcCTJtMCGk9VE4dovV+sZY81xbMNsgXrEvCRSIgDN1ntqV667BtKqRki/8uuFfDA26CF1/7bVathaZF0/7HZ/9SOB/R8CZUAG7evN1jLpjGTbJAT8B+BNSWlfiesd7if2phHEp+xnJRgLRJuCWTUFmcTqDopLnkZLd+aLNL6S0vozOK9sTH20Q49pP+cbjcxKIDAF37P3IPPOaonj8WqTkrYECG1hI9dooV9vXZ0Ukf/4WGUAMhAT8EtA77+4Wk95V/jpSsqE/u1sLaa+a+B475eezqxL7a0VuhN6n8usv+5HAiCWgo8cgs7he9b5puzAZq7FMnP86e7OQ6nQ0LOyRC6eSiZatInbXiA2QjpHAcBFQaxQy1ZtVJ85qho0VqJMbfef+t5AatQQ2mo2zRx+3Dr8JcW8S3nD5zXlIYMQRUMOEvfAVuNPmH4OFJGqkw3MyJ6Q6LYOFVuP0xzOstnchyO73spEACfQloBDY816AW7HkG9ioRJ1cyj7vEVK9ToLgsHl81yTr5B6SIwESyEPAnr0CztxV56FYiFo5L2jQmXDcQ9bRHaXmt4fyL4cTMQmQQDcB56EqteevuQzTqBJs6frdOtBYbP7wOUXEBCGBgAScBx9Te1FNJ4UUEBy7k0BfAjkheZ92n+woNc/w045pQgJ+CTjTq9R+yvu0yy02HDGPv/+AdfJDv+OwHwnEloA9ezmcuc/9CMWCnsUGrzVpGf7OLn/vm2G17eTyd2xThIEPRKBn+Xs13Iqlt1j+9iy5IcssIoF+CfjbkPXMe48IfZlMtNTziBATiwQA9BwRqlWd+IiPI0IeMh5aZfKQQC+BcIdW+wLkNQqmU8wJ9F6jGFfehFqp6Q9H/k3Y7MW+jsvbE/s28mJfzJMqbuF3X+xbuk1RUjrIi30eOV41j1sOxT7eob9q7iH1ip80byky27+KPWgCiC4Bp/xh2MlXb0Pxk9ybieW4ops/jCx7EPW2l+PKvZlYIJIpF0kCw1cgMvdmYsniSKZSPIMqTMlijzWL6Mcz6yIYdeGK6Hsw+VuXCKZVDEMagt+6/AM+iaFswtP+FAAAAABJRU5ErkJggg==) no-repeat;
    position: absolute;
    top: -15px;
    left: 350px;
    text-align: center;
    line-height: 30px;
    font-weight: 500;
    color: #17ECFE;
    font-size: 18px;

    .titletext {
      margin: 0 20px;
    }
  }

  .ang1 {
    position: absolute;
    left: -3px;
    top: -3px;
  }

  .ang2 {
    position: absolute;
    right: -3px;
    top: -3px;
  }

  .ang3 {
    position: absolute;
    left: -3px;
    bottom: -3px;
  }

  .ang4 {
    position: absolute;
    right: -3px;
    bottom: -3px;
  }

  .responsible-category-area {
    margin-top: 27px;
    margin-bottom: 28px;
    display: flex;
    align-items: center;

    .responsible-title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #17ECFE;

      span {
        color: #FF7D00;
      }
    }
  }

  .responsible-person-area {
    padding: 23px 34px 26px;
    border-top: 1px solid #0084FF;

    .responsible-person-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #17ECFE;
      display: flex;
      align-items: center;

      span {
        color: #FF7D00;
      }
    }

    .responsible-person-children {
      margin-top: 24px;
      display: flex;
      flex-wrap: wrap;

      .responsible-person-children-row {
        width: 50%;
        display: flex;
        align-items: center;
        padding-left: 73px;

        &:nth-child(n+1) {
          margin-top: 26px;
        }

        .responsible-person-children-title {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #17ECFE;
        }

        .el-checkbox {
          display: flex;
          align-items: center;

          .el-checkbox__input {
            display: flex;
            align-items: center;

            .el-checkbox__inner {
              background: transparent !important;
              border: 1px solid #0EBD35 !important;
            }
          }

          .el-checkbox__label {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #B1E3FF;
          }
        }
      }
    }

    .responsible-submission-area {
      margin-top: 43px;
      padding: 0 68px;

      .responsible-submission {
        background: url("./responsibility/images/dirFile.png") no-repeat;
        background-size: 22px 22px;
        background-position: left center;
        padding-left: 31px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0EBD35;
        cursor: pointer;
      }
    }

    .responsible-person-btn-area {
      margin-top: 42px;
      display: flex;
      align-items: center;
      justify-content: center;

      .responsible-person-btn {
        width: 160px;
        height: 42px;
        background: rgba(14, 189, 53, 0.1);
        border-radius: 4px;
        border: 1px solid #0EBD35;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0EBD35;
        cursor: pointer;
      }
    }
  }

  .add-accident-certificate-area {
    border-top: 1px solid #0084FF;
    padding-top: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    .add-accident-certificate-btn {
      padding-left: 21px;
      background: url("./responsibility/images/addIcon.png") no-repeat 100%;
      background-position: left center;
      background-size: 18px 18px;
      cursor: pointer;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0EBD35;
      cursor: pointer;
    }
  }

  .liability-list {
    list-style: none;
    padding: 0;
    margin: 0;

    .party-name {
      margin-bottom: 15px;
      font-size: 18px;
      font-weight: 400;
      color: #0EBD35;
      line-height: 16px;
    }
  }
}

.canclebtn {
  background: rgba(0, 132, 255, 0.1);
  border-radius: 4px;
  border: 1px solid #0084FF;
}

.confirmbtn {
  background: rgba(14, 189, 53, 0.1);
  border-radius: 4px;
  border: 1px solid #0EBD35;
}

.el-dialog .el-dialog__header {
  background-color: #0F1F46;
  color: #0F1F46;

  .el-dialog__headerbtn .el-dialog__close {
    color: #0F1F46;
  }
}

.el-dialog--center .el-dialog__body {
  background-color: #0F1F46;
}

.el-dialog__footer {
  background-color: #0F1F46 !important;
}

.el-form-item--medium .el-form-item__label {
  color: #17ECFE;
}

.el-dialog__title {
  color: #17ECFE;
  font-size: 18px;
}

#textcontent {
  background-color: #0F1F46;
  color: #17ECFE;
  border: 2px solid #17ECFE;
  font-size: 20px;
}
</style>
